import { Component, Event, Host, EventEmitter, h, Prop } from '@stencil/core';
import { CssClassMap } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-button',
  styleUrl: 'cms-button.scss',
  shadow: true,
})
export class CmsButton {
  /**
   * fired the custom event cmsButtonClick
   */

  @Event({
    eventName: 'cmsButtonClick',
    composed: true,
    bubbles: true,
  })
  cmsButtonClick: EventEmitter;

  /**
   * set the button disabled
   */
  @Prop({ reflect: true }) disabled: boolean;

  /**
   * set the button type
   */
  @Prop({ reflect: true }) type: 'button' | 'reset' | 'submit' = 'button';
  /**
   * set the button size
   */
  @Prop({ reflect: true }) size: 'button-sm' | 'button-md' | 'button-xl' =
    'button-sm';
  /**
   * set the button color
   */
  @Prop({ reflect: true}) theme: 'ghost-dark' | 'ghost-light' | 'brand-1' =
    'ghost-dark';
  /**
   * set the button Label
   */
  @Prop({ reflect: true }) label: string;

  private cmsButtonClickHandler = () => {
    this.cmsButtonClick.emit({ message: 'clicked' });
  };

  private getCssClassMap(): CssClassMap {
    return {
      [this.theme]: true,
      [this.size]: true,
    };
  }
  private classMap = this.getCssClassMap();

  render() {
    return (
      <Host>
        <button
          onClick={() => {
            this.cmsButtonClickHandler();
          }}
          type={this.type}
          class={this.classMap}
          disabled={this.disabled}
        >
          <span class={'button-label'}>{this.label} </span>
        </button>
      </Host>
    );
  }
}
